module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/pJeCEa/image/9781532402548.jpg?1698597632635",
      "alt": "This image is the cover for the book Discover Ancient Egypt, Discover Reading"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Discover Ancient Egypt, Discover Reading\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Monkey Fun! proves that you’re never too young to begin your learning adventure.  It’s a barrel of fun and chock full of interesting monkey facts written in easy to understand rhyming verse for toddlers ages 0-4.   “That’s not a monkey who’s peeling a grape.  Bigger and tailless, he must be an ape.”  “Monkeys who live in a family group, travel together and share with their troop.”   Bold, colorful illustrations by Aida Barba Flores will capture the attention of young readers and aid in story comprehension. This is an edutaining rhyming adventure that offers fun learning resources in the back of the book including, Mrs. Dweck’s monkey facts and a monkey counting game.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Amanda Trane\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Amanda Trane has never actually ridden on a train, but she's heard that joke a lot of times. An educator and lover of children's literature, Amanda writes cute books for cute kids. She loves learning and hopes to help kids love it too.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Xist Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0